module.exports = __webpack_public_path__ + "static/media/Lord Voldemort 3.cb39f94d.jpg";